<template>
  <div>
    <el-form-item :required="required" label="建物" :label-width="labelWidth">
      <el-row :gutter="gutter">
        <el-col :span="localSpan1" class="col_positon">
          <el-form-item ref="elFormItem" :prop="prop" :rules="rules">
            <el-input
              v-model="localBlgscd"
              class="left_input"
              :disabled="showList || localDisabled"
              :class="[showList ? 'multiple' : '']"
              @input="handleLocalInputVal"
              @blur="handleBuildingBlur"
            />
            <template #error="{ error }">
              <el-tooltip
                class="item"
                effect="dark"
                :content="error"
                placement="bottom"
              >
                <div class="el-form-item__error">{{ error }}</div>
              </el-tooltip>
            </template>
            <div
              v-if="!localDisabled"
              class="more_box flex_center flex_center_align"
              @click="selectDep"
            >
              <svg-icon icon-class="select"></svg-icon>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="localSpan2">
          <el-select
            v-show="showBldgcd"
            v-model="localBldgcd"
            class="middle_input"
            placeholder="棟"
            :clearable="multiSelect"
            :disabled="localDisabled"
            @change="selectionChanged"
          >
            <el-option
              v-for="item in bldgcdList"
              :key="item.bldgcd"
              :label="item.bldgcd"
              :value="item.bldgcd"
            >
              <span style="float: left">{{ item.bldgcd }}</span>
              <span style="float: right; margin-left: 20px; font-size: 13px">
                {{ item.blgsbldgkj }}
              </span>
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="localSpan3">
          <el-input
            v-model="localBlgsnmkj"
            class="right_input"
            :class="[showList ? 'multiple' : '']"
            disabled
          />
          <el-popover v-show="showDetailBtn" placement="bottom" trigger="click">
            <el-table :data="list" border stripe>
              <el-table-column
                width="80"
                property="blgscd"
                label="建物CD"
              ></el-table-column>
              <el-table-column
                width="120"
                property="blgsnmkj"
                label="建物名"
              ></el-table-column>
            </el-table>
            <div
              slot="reference"
              class="more_box flex_center flex_center_align more_change_box"
            >
              <div class="inner_box flex_center flex_center_align">
                <svg-icon :icon-class="'sel'"></svg-icon>
              </div>
            </div>
          </el-popover>
        </el-col>
      </el-row>
    </el-form-item>
    <build-dialog
      :visible.sync="dialogVisible"
      :multi-select="multiSelect"
      @get-selection="getSelection"
    />
  </div>
</template>

<script>
  let format = require('string-format')
  import mixComponent from '@/utils/mixComponent'
  import { getmbuildgp } from '@/api/mbuildgp'
  export default {
    name: 'Building',
    mixins: [mixComponent],
    props: {
      gutter: {
        type: Number,
        default: 0,
      },
      labelWidth: {
        type: String,
        default: null,
      },
      span1: {
        type: Number,
        default: 5,
      },
      span2: {
        type: Number,
        default: 3,
      },
      span3: {
        type: Number,
        default: 14,
      },
      span4: {
        type: Number,
        default: 2,
      },
      //建物ＣＤ
      blgscd: {
        type: [String, Array],
        default: null,
      },
      //棟ＣＤ
      bldgcd: {
        type: String,
        default: null,
      },
      //
      disabled: {
        type: Boolean,
        default: false,
      },
      // 建物名
      blgsnmkj: {
        type: String,
        default: null,
      },
    },
    data() {
      return {
        showBldgcd: true,
        showDetailBtn: false,
        list: [],
        showList: false,
        bldgcdList: [],
        localBlgscd: this.blgscd,
        localBldgcd: this.bldgcd,
        localBlgsnmkj: this.blgsnmkj,
        dialogVisible: false,
        localSpan1: this.span1,
        localSpan2: this.span2,
        localSpan3: this.span3,
        localSpan4: this.span4,
        localDisabled: this.disabled,
      }
    },
    computed: {},
    methods: {
      handleBuildingBlur(event) {
        if (this.prop) {
          return
        }
        let val = event.target.value
        this.$emit('update:blgscd', this.multiSelect ? [val] : val)
      },
      selectBuilder() {
        this.dialogVisible = true
      },
      selectionChanged(val) {
        this.$emit('update:bldgcd', val)
      },
      async remote(rule, value, callback) {
        if (this.validated) {
          return
        }
        value = this.localBlgscd
        if (this.required) {
          if (this.$baseLodash.isEmpty(value)) {
            this.localBlgsnmkj = ''
            this.localBldgcd = null
            this.bldgcdList.splice(0)
            this.$emit('blur', { value: value, hasError: true })
            return callback(
              new Error(
                this.$t(`validateMessage.${this.$messageCode.E00000001.name}`)
              )
            )
          }
        }

        if (this.$baseLodash.isEmpty(value)) {
          this.localBlgsnmkj = ''
          this.localBldgcd = null
          this.bldgcdList.splice(0)
          return
        }
        const data = await getmbuildgp(value)
        if (this.$baseLodash.isEmpty(data)) {
          this.localBlgsnmkj = ''
          this.localBldgcd = null
          this.bldgcdList.splice(0)
          this.$emit('blur', { value: value, hasError: true })
          return callback(
            new Error(
              format(
                this.$t(`validateMessage.${this.$messageCode.E00000007.name}`),
                '建物CD',
                '建物基本マスタ'
              )
            )
          )
        } else {
          this.remoteCheck = false
          let result = null
          //拡張された検証メソッドを呼び出す
          if (this.$baseLodash.isFunction(this.validate)) {
            let f = this.validate.call(this, data)
            if (f instanceof Promise) {
              result = await f
            } else {
              result = f
            }

            if (result.error) {
              this.$emit('blur', { value: value, hasError: true })
              return callback(
                new Error(format(result.message, this.codeEnum.code))
              )
            }
          }
          this.setBldg(data)
        }

        this.validated = true
        callback()
        this.$emit('blur', { value: value, hasError: false, model: data })
      },
      async getSelection(val) {
        if (val.length == 0) {
          this.showBldgcd = true
          this.showDetailBtn = false
          this.bldgcdList = []
          this.localBlgscd = ''
          this.localBldgcd = ''
          this.localBlgsnmkj = null
          this.localSpan3 = this.span3
          this.showList = false
          this.localDisabled = false
          this.$emit('update:blgscd', null)
          this.$emit('update:bldgcd', null)
        } else {
          if (val.length > 1) {
            this.localBlgsnmkj = this.localBlgscd = '<複数>'
            this.showDetailBtn = true
            this.showBldgcd = false
            this.localSpan3 = this.span3 + this.span2
            this.$emit('update:blgscd', this.$baseLodash.map(val, 'blgscd'))
            this.showList = true
            //this.localDisabled = true
          } else {
            const list = await getmbuildgp(val[0].blgscd)
            this.setBldg(list)
            this.showList = false
            //this.localDisabled = false
          }
          this.list = val
        }
        this.remoteCheck = false
        this.validated = false
        this.$refs['elFormItem']?.clearValidate()
        this.form.validateField(this.prop)
        this.$emit('getData', val)
      },
      //建物棟の情報を設置する
      setBldg(data) {
        if (data.length == 1) {
          this.showBldgcd = false
        } else {
          this.bldgcdList = data
          this.showBldgcd = true
        }

        this.localBlgsnmkj = data[0].blgsnmkj
        this.localBldgcd = data[0].bldgcd
        this.localBlgscd = data[0].blgscd
        this.showDetailBtn = false
        if (!this.showBldgcd && !this.showDetailBtn) {
          this.localSpan3 = this.span3 + this.span2
        } else {
          this.localSpan3 = this.span3
        }
        this.$emit('update:blgscd', data[0].blgscd)
        this.$emit('update:bldgcd', data[0].bldgcd)
        this.$emit('update:blgsnmkj', data[0].blgsnmkj)
      },
      /**
       * 建物コンポネートの設置する
       * @param {*} blgscd 建物CD
       * @param {*} bldgcd 棟CD
       * @param {*} blgsnmkj 建物名
       */
      async setValue(blgscd, bldgcd, blgsnmkj) {
        const list = await getmbuildgp(blgscd)
        this.setBldg(list)
        this.localBlgscd = blgscd
        this.localBldgcd = bldgcd
        this.localBlgsnmkj = blgsnmkj
      },
      setDisabled(disabled) {
        this.localDisabled = disabled
      },
      fetchData() {
        this.$refs.table?.fetchData()
      },

      reset() {
        this.localBlgscd = null
        this.localBldgcd = null
        this.localBlgsnmkj = null
        this.list = []
        this.showList = false
        this.validated = false
        this.showDetailBtn = false
        this.$emit('update:blgscd', null)
        this.$emit('update:bldgcd', null)
        this.$emit('update:blgsnmkj', null)
      },
    },
  }
</script>
<style lang="scss" scoped>
  @import '@/vab/styles/component.scss';
</style>
